import { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext } from "@tanstack/react-router"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { RouteError, RouteNotFound } from "modules/shared/components/NotFound"
import { useAuth } from "modules/shared/hooks/useAuth"
import { baseBeforeLoad } from "./_base/route"

import "modules/shared/lang"

type RouteContext = {
  queryClient: QueryClient
  auth: ReturnType<typeof useAuth>
  localUser: ReturnType<typeof useAuthEmployeeQuery>["data"]
}

export const Route = createRootRouteWithContext<RouteContext>()({
  notFoundComponent: () => <RouteNotFound />,
  errorComponent: (props) => <RouteError {...props} />,
  beforeLoad: async (props) => baseBeforeLoad(props),
})
